module.exports = __webpack_public_path__ + "img/voltaje_b_blue.064b937a.svg";